<template>
  <div>
    <div class="top-left whiteBg">
      <el-card class="box-cards">
        <div slot="header" class="clearfix">
          <span>业务待办数量</span>
        </div>
        <div class="cards-content">
          <div class="type-num">
            <div
              class="type-num-flex"
              v-for="(item, index) in dealData"
              :key="index"
              @click="jumpNode(item.nodeName)"
            >
              <div class="num-top">
                <div>
                  <template v-if="index == 0">
                    <img src="@/assets/img/home/top_11.png" alt />
                  </template>
                  <template v-else-if="index == 1">
                    <img src="@/assets/img/home/top_22.png" alt />
                  </template>
                  <template v-else-if="index == 2">
                    <img src="@/assets/img/home/top_33.png" alt />
                  </template>
                  <template v-else>
                    <img src="@/assets/img/home/top_44.png" alt />
                  </template>
                </div>
                <div class="top-title">
                  <span>{{ item.nodeName }}</span>
                  <span>{{ item.totalCount }}</span>
                </div>
              </div>
              <div class="num-bottom">
                <div>
                  首次提交
                  <span>{{ item.firstSubmitCount }}</span>
                </div>
                <div>
                  退回后提交
                  <span>{{ item.returnCount }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="type-table">
            <el-table
              :data="tableData"
              :header-cell-style="this.$globalGrayTableHeaderStyle"
              :height="251"
              stripe
              @filter-change="filterChange"
              class="table-content hide-scrollbar"
              ref="multipleTable"
              v-loading="dataListLoading"
            >
              <el-table-column
                :index="indexMethod"
                align="center"
                fixed
                label="序号"
                type="index"
                width="50"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                :label="`项目/${
                  filters.field4 == '其他' ? '任务' : '标段'
                }名称`"
                prop="field3"
                header-align="left"
                align="left"
                min-width="200"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                :label="`项目/${
                  filters.field4 == '其他' ? '任务' : '标段'
                }编号`"
                prop="field2"
                header-align="left"
                align="left"
                min-width="180"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                :filters="flowNameData"
                label="业务节点"
                prop="field4"
                header-align="left"
                align="left"
                min-width="100"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="提交时间"
                sortable
                prop="fromTime"
                header-align="center"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                label="操作"
                v-if="hasBtnPermission('supperviseion_home_to_todo_btn')"
                width="200"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    title="查看"
                    @click="jump(scope.row)"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <paginationCom
              @sizechange="sizeChangeHandle"
              @pagechange="pageChangeHandle"
              class="limit"
              :options="paginationOpt"
            ></paginationCom>
          </div>
        </div>
      </el-card>
    </div>
    <div class="top-right">
      <!-- <el-card class="box-cards"> -->
      <!-- <div slot="header" class="clearfix">
                    <span>音视频网格化监管</span>   
      </div>-->
      <div class="cards-content">
        <div class="video-num">
          <!-- <div class="video-padding" @click="jump1(1)">
                            <div class="video-title">本月开标监管数量</div>
                            <div class="video-content"> 
                                <div><span>{{openEvalStatusData.bidopenMonthCount}}</span> 宗</div>
                                <img src="@/assets/img/home/right_blue.png" alt="">
                            </div>
                        </div>
                        <div class="video-padding" @click="jump1(1)">
                            <div class="video-title">本月评标监管数量</div>
                            <div class="video-content"> 
                                <div><span>{{openEvalStatusData.evalMonthCount}}</span> 宗</div>
                            </div>
                        </div>
                        <div class="video-padding" @click="jump1(1)">
                            <div class="video-title">本年开标监管数量</div>
                            <div class="video-content"> 
                                <div><span>{{openEvalStatusData.bidopenYearCount}}</span> 宗</div>
                                <img src="@/assets/img/home/right_pink.png" alt="">
                            </div>
                        </div>
                        <div class="video-padding" @click="jump1(1)">
                            <div class="video-title">本年评标监管数量</div>
                            <div class="video-content"> 
                                <div><span>{{openEvalStatusData.evalYearCount}}</span> 宗</div>
                                <img src="@/assets/img/home/right_green.png" alt="">
                            </div>
          </div>-->
          <div class="video-padding" @click="jump1(1)">
            <div class="video-title">
              <img src="@/assets/img/date.png" alt class="datePng" />
              <span class="title_text">今日开标项目</span>
            </div>
            <div class="video-content topbg">
              <div>
                <span class="firstSpan">{{
                  bidOpenCountObj.bidOpenTodayCount || 0
                }}</span>
                宗
              </div>
              <!-- <img src="@/assets/img/home/right_green.png" alt=""> -->
            </div>
          </div>
          <div class="video-padding avrage left" @click="jump1(1)">
            <div class="video-title">本周待开标</div>
            <div class="video-content">
              <div>
                <span>{{ bidOpenCountObj.bidopenWeekCount || 0 }}</span> 宗
              </div>
            </div>
          </div>
          <div class="video-padding avrage" @click="jump1(1)">
            <div class="video-title">本月待开标</div>
            <div class="video-content">
              <div>
                <span>{{ bidOpenCountObj.bidopenMonthCount || 0 }}</span> 宗
              </div>
            </div>
          </div>
        </div>
        <div class="system-jump">
          <!-- <div @click="jump1(1)">
                            <img src="@/assets/img/home/microphone.png" alt="">
                            <div>项目开评标音视频监管入口</div>
                            <div class="el-icon-arrow-right"></div>
                        </div>
                        <div @click="jump1(2)">
                            <img src="@/assets/img/home/flag.png" alt="">
                            <div>专家活动轨迹监管入口</div>
                            <div class="el-icon-arrow-right"></div>
                        </div>
                        <div @click="jump1(3)">
                            <img src="@/assets/img/home/notebook.png" alt="">
                            <div>评标出入门禁监管入口</div>
                            <div class="el-icon-arrow-right"></div>
                        </div>
                        <div @click="jump1(4)">
                            <img src="@/assets/img/home/expert.png" alt="">
                            <div>专家抽取监管入口</div>
                            <div class="el-icon-arrow-right"></div>
          </div>-->
          <div class="top_systemInto">
            <!--  @click="jump1(5)" -->
            <div class="leftInto" @click="jump1(7)">
              <div class="left_margin">
                <div>项目投诉</div>
                <div>监管入口</div>
              </div>
            </div>
            <div class="rightInto" @click="jump1(1)">
              <div class="left_margin">
                <div>项目开评标音视频</div>
                <div>监管入口</div>
              </div>
            </div>
          </div>

          <div class="top-middle-right">
            <div class="num-blue projectAll" ref="numblue">
              <div
                class="blueNum_bg"
                @click="jump('businessWitnessHis', 1)"
                :style="{ width: numBlueLeftWidth }"
              >
                <div>已完结项目</div>
                <div>
                  <span>{{ projectCountData.finishCount }}</span> 宗
                </div>
              </div>
              <div class="content" :style="{ left: numWhiteLeftWidth }"></div>
              <div
                class="grayNum_bg"
                @click="jump('businessWitnessHis', 2)"
                :style="{ width: numGrayrightWidth }"
              >
                <div>未完结项目</div>
                <div>
                  <span>{{ projectCountData.notFinishCount }}</span> 宗
                </div>
              </div>
            </div>
            <div class="handle_count">
              <div class="num-yellow" @click="jump1(7)">
                <div>待处理投诉数量</div>
                <div>
                  <span>{{ projectCountData.receiveCount }}</span
                  >宗
                </div>
                <img
                  src="@/assets/img/home/complaint.png"
                  alt
                  style="width: 56px; height: 56px"
                />
              </div>
              <div class="num_red" @click="jump1(7, {tabActived:'all', dateRange: 30})">
                <div>近30日投诉</div>
                <div>
                  <span>{{ projectCountData.nearlyMonthReportCount || 0 }}</span
                  >条
                </div>
                <img src="@/assets/img/light.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </el-card> -->
    </div>
  </div>
</template>
<script>
import { findMenuItem } from "@/utils/index";
import { mapState } from "vuex";
export default {
  data() {
    return {
      paginationOpt: {
        pageIndex: 1,
        pageSize: 5,
        total: 0,
        pageSizes: [5, 20, 50],
      },
      dataListLoading: false,
      checkedBtn: 1,
      tableData: [],
      dealData: [],
      openEvalStatusData: {},
      flowNameData: [],
      filters: { datasetCode: "" },
      bidOpenCountObj: {},

      projectCountData: {
        finishCount: 0,
        notFinishCount: 0,
        total: 0,
        nearlyMonthReportCount: 0,
      },
      numBlueLeftWidth: "",
      numWhiteLeftWidth: "",
      numGrayrightWidth: "",
    };
  },
  created() {
    this.getProjectData();
    this.getData();
    this.getDealData();
    this.getOpenEvalStatusData();
    // 获取首页开标统计
    this.getBidOpenCountData();

    this.getFlownodesList();
  },
  watch: {
    uerdefultOptionCode: {
      handler(val, oldVal) {
        if (val.length !== 0) {
          this.getBidOpenCountData();
        }
      },
    },
    numBlueLeftWidth(val) {
      this.numBlueLeftWidth = val;
    },
    numWhiteLeftWidth(val) {
      this.numWhiteLeftWidth = val;
    },
    numGrayrightWidth(val) {
      this.numGrayrightWidth = val;
    },
  },

  mounted() {
    this.computeWidth();
    this.cancalDebounce = this.debounce(this.computeWidth, 100);
    window.addEventListener("resize", this.cancalDebounce);
  },

  computed: {
    ...mapState({
      uerdefultOptionCode: (state) => state.dataDictionary.uerdefultOptionCode,
    }),
  },
  methods: {
    debounce(fn, wait) {
        let timeout = null;
        return function() {
            let context = this;
            let args = arguments;
            if (timeout) clearTimeout(timeout);
            let callNow = !timeout;
            timeout = setTimeout(() => {
                timeout = null;
            }, wait);
            if (callNow) fn.apply(context, args);
        };
    },
    indexMethod(index) {
      return (
        (this.paginationOpt.pageIndex - 1) * this.paginationOpt.pageSize +
        index +
        1
      );
    },
    // 每页长度改变待办事项
    sizeChangeHandle(value) {
      this.paginationOpt.pageSize = value;
      this.paginationOpt.pageIndex = 1;
      this.getData();
    },
    // 当前页改变待办事项
    pageChangeHandle(value) {
      this.paginationOpt.pageIndex = value;
      this.getData();
    },
    async jump(item) {
      // 跳转详情
      await findMenuItem(
        JSON.parse(sessionStorage.getItem("menuList")),
        "busWitness_list"
      );
      let goToUrl = item.url || "";
      this.$router.push({ path: goToUrl });
    },
    async jump1(type, params) {
      if (type == 1) {
        // 待完成：本账号就一个标段在开评标，点击模块区域，直接进项目
        if (
          !this.hasBtnPermission("supperviseion_home_to_openBidWitness_btn")
        ) {
          this.$message.error("您无权限跳转音视频监管页面");
          return;
        }
        await findMenuItem(
          JSON.parse(sessionStorage.getItem("menuList")),
          "openBidAndEstimateWitness_list"
        );
        this.$router.push({
          name: "openBidAndEstimateWitness_list",
        });
      } else if (type == 2) {
        if (!this.hasBtnPermission("supperviseion_home_to_track_btn")) {
          this.$message.error("您无权限跳转专家活动轨迹监管页面");
          return;
        }
        await findMenuItem(
          JSON.parse(sessionStorage.getItem("menuList")),
          "track_witness"
        );
        this.$router.push({
          name: "track_witness",
        });
      } else if (type == 3) {
        if (!this.hasBtnPermission("supperviseion_home_to_guard_btn")) {
          this.$message.error("您无权限跳转评标出入门禁监管页面");
          return;
        }
        await findMenuItem(
          JSON.parse(sessionStorage.getItem("menuList")),
          "realtime_guardwitness_list"
        );
        this.$router.push({
          name: "realtime_guardwitness_list",
        });
      } else if (type == 5) {
        if (
          !this.hasBtnPermission(
            "supperviseion_home_to_expertWitness_detail_btn"
          )
        ) {
          this.$message.error("您无权限跳转专家抽取详情页");
          return;
        }
        await findMenuItem(
          JSON.parse(sessionStorage.getItem("menuList")),
          "expertWitness_detail"
        );
        this.$router.push({
          name: "expertWitness_detail",
        });
      } else if (type == 6) {
        if (
          !this.hasBtnPermission(
            "supperviseion_home_to_project_extract_list_btn"
          )
        ) {
          this.$message.error("您无权限跳转项目双随机抽取页面");
          return;
        }
        await findMenuItem(
          JSON.parse(sessionStorage.getItem("menuList")),
          "project_extract_list"
        );
        this.$router.push({
          name: "project_extract_list",
        });
      }else if (type == 7) {
        if (
            !this.hasBtnPermission(
                "online_complaints_btn_add"
            )
        ) {
          this.$message.error("您无权限跳转项目投诉页面");
          return;
        }
        await findMenuItem(
            JSON.parse(sessionStorage.getItem("menuList")),
            "online_complaints_list"
        );
        this.$router.push({
          name: "online_complaints_list",
          query:{...params}
        });
      } else {
        if (!this.hasBtnPermission("supperviseion_home_to_expertWitnes_btn")) {
          this.$message.error("您无权限跳转专家抽取监管页面");
          return;
        }
        await findMenuItem(
          JSON.parse(sessionStorage.getItem("menuList")),
          "expertWitness_list"
        );
        this.$router.push({
          name: "expertWitness_list",
        });
      }
    },
    getData() {
      // 获取列表数据
      this.dataListLoading = true;
      this.$httpReq
        .post("/userTask/list", {
          page: this.paginationOpt.pageIndex,
          rows: this.paginationOpt.pageSize,
          //   filter: {
          //  datasetCode: this.filters.datasetCode
          //   }
          filter: this.filters,
        })
        .then((res) => {
          this.tableData = res.data.rows;
          this.paginationOpt.total = res.data.total;
          this.dataListLoading = false;
        });
    },
    // getData(node) {
    //   // 获取列表数据
    //   this.dataListLoading = true;
    //   this.$httpReq
    //     .post("/businessFlowWitness/list", {
    //       page: this.paginationOpt.pageIndex,
    //       rows: this.paginationOpt.pageSize,
    //       filter: {
    //         businessType: "GC",
    //         witnessStatus: 1,
    //         datasetCode: this.filters.datasetCode
    //       }
    //     })
    //     .then(res => {
    //       this.tableData = res.data.rows;
    //       this.paginationOpt.total = res.data.total;
    //       this.dataListLoading = false;
    //     });
    // },
    getDealData() {
      this.$httpReq({
        //业务待办数量
        url: "/homePage/listDealCount",
        method: "get",
      }).then(({ data }) => {
        if (data.code == 1) {
          this.dealData = data.data;
        }
      });
    },
    getBidOpenCountData() {
      this.$httpReq({
        url: "/openevalsupervise/getBidOpenCount",
        method: "post",
        data: { superviseDeptCodeList: this.uerdefultOptionCode },
      }).then(({ data }) => {
        if (data.code == 1) {
          this.bidOpenCountObj = data.data;
        }
      });
    },

    getOpenEvalStatusData() {
      //音视频网格化监管
      this.$httpReq({
        //业务待办数量
        url: "/openevalsupervise/getOpenEvalStats",
        method: "post",
        data: { superviseDeptCodeList: this.uerdefultOptionCode },
      }).then(({ data }) => {
        if (data.code == 1) {
          this.openEvalStatusData = data.data;
        }
      });
    },
    jumpNode(node) {
      //跳转
      //   this.filters.datasetCode = node;
      // 清除所有过滤器
      this.$refs.multipleTable.clearFilter();
      if (node == "招标文件") {
        this.filters = { field4List: [node, "招标文件澄清与修改"] };
      } else {
        this.filters = { field4: node };
      }
      this.getData();
    },
    filterChange(filters) {
      let filtersParams = {};

      for (var i in filters) {
        var filtersArr = filters[i];
        let key = "",
          value = [];
        filtersArr.length > 0 &&
          filtersArr.forEach((item) => {
            key = item.split("_")[0];
            value.push(item.split("_")[1]);
          });
        key && value.length > 0
          ? (filtersParams[key] = value.toString())
          : null;
      }
      if (filtersParams["field4List"]) {
        filtersParams["field4List"] = filtersParams["field4List"].split(",");
      }
      this.filters = filtersParams;
      this.getData();
    },
    getFlownodesList() {
      //业务节点下拉框
      this.$httpReq
        .post("/configs/sysFlowNodeConfig/list", {
          page: 1,
          rows: 200,
          filter: {
            busType: "GC",
            enableHandle: 1,
          },
        })
        .then((res) => {
          this.flowNameData = [];
          for (var i in res.data.rows) {
            this.flowNameData.push({
              text: res.data.rows[i].nodeName,
              //   value: "datasetCode_" + res.data.rows[i].datasetCode
              value: "field4List_" + res.data.rows[i].nodeName,
            });
          }
        });
    },

    getProjectData() {
      //首页数量数据
      this.$httpReq({
        //获取项目完结，未完结，待受理投诉数据
        url: "/homePage/getWarnCount",
        method: "get"
      }).then(({ data }) => {
        if (data.code == 1) {
          this.projectCountData = data.data;
          this.projectCountData.total =
            Number(this.projectCountData.finishCount) +
            Number(this.projectCountData.notFinishCount);

          this.showChart();
        }
      });
    },

    computeWidth(){
        this.numBlueLeftWidth=this.dealNumberFn('left');
        this.numWhiteLeftWidth=this.dealNumberFn('content');
        this.numGrayrightWidth=this.dealNumberFn('right');
    },

    dealNumberFn(type) {
      let finishCount = this.projectCountData.finishCount;
      let notFinishCount = this.projectCountData.notFinishCount;
      let total = this.projectCountData.total;
      let parentWidth = document.body.clientWidth * 0.255 - 55;
      // 0或平均值时 位置和宽度处理
      //   if (total == 0 || finishCount / total == 0.5) {
      //     if (type == "left" || type == "right") {
      //       return "calc(50% " + (type == "left" ? "+" : "-") + " 25px)";
      //     }
      //     if (type == "middle") {
      //       return parentWidth * 0.5 - 19 + "px";
      //     }
      //   }
      // 0或平均值时 位置和宽度处理2
      if (total == 0 || finishCount / total == 0.5) {
        if (type == "left" || type == "right") {
          return "50%";
        }
        if (type == "content") {
          return "calc(50% - 12px)";
        }
      }
      let leftPercent = finishCount / total;
      let leftPost = parentWidth * leftPercent;
      if (type == "left") {
        return "calc(" + (finishCount / total) * 100 + "% )";
      }
      if (type == "right") {
        return "calc(" + (notFinishCount / total) * 100 + "% )";
      }
      // 计算中间位置，需要考虑最左和最右极限值
      if (type == "content") {
        let dataleft = (finishCount / total) * 100;
        let dataleftWifth = (parentWidth * dataleft) / 100;
        let dataRightWifth = parentWidth - dataleftWifth;
        // console.log(parentWidth, dataleft, (parentWidth * dataleft) / 100);
        if (dataRightWifth < 90) {
          return `${parentWidth - 109}px`;
        }
        if (dataleftWifth < 90) {
          return `78px`;
        }
        return `${dataleftWifth - 15}px`;
      }
      //   if (type == "middle") {
      //     if (leftPost < 113) {
      //       // 最左
      //       return 113 + "px";
      //     } else if (parentWidth - leftPost < 145) {
      //       // 最右
      //       return parentWidth - 167 + "px";
      //     } else {
      //       return leftPost - 16 + "px";
      //     }
      //   }
    },
  },
};
</script>
<style lang="scss" scoped>
.top-left {
  width: 74.5%;
  margin-right: 24px;
  .type-num {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .type-num-flex {
      flex: 1;
      margin-right: 32px;
      &:nth-of-type(1) {
        .num-top {
          background: url("../../../assets/img/home/top_1.png") no-repeat;
        }
      }
      // 波浪图片
      &:nth-of-type(2) {
        .num-top {
          background: url("../../../assets/img/home/top_2.png");
        }
      }
      &:nth-of-type(3) {
        .num-top {
          background: url("../../../assets/img/home/top_3.png");
        }
      }
      &:nth-of-type(4) {
        .num-top {
          background: url("../../../assets/img/home/top_4.png");
        }
      }
    }
    .num-bottom {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 14px;
    }
  }
  .type-table {
    margin-top: 42px;
  }
  .num-top {
    width: 100%;
    height: 128px;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    display: flex;
    cursor: pointer;
    &:hover img {
      margin-top: 0;
    }
    img {
      margin-top: 10px;
    }
    .top-title {
      margin-top: 29px;
      span {
        display: block;
        font-weight: 600;
        &:nth-of-type(1) {
          font-size: 14px;
          margin-bottom: 9px;
        }
        &:nth-of-type(2) {
          font-size: 32px;
        }
      }
    }
  }
}
.top-right {
  width: calc(25.5% - 24px);
  .video-num {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 24px;
    & > div {
      width: 100%;
      height: 93px;
      background: #ffffff;
      border-radius: 10px;
      // &:nth-of-type(2n-1) {
      //   // margin-right:16px ;
      //   margin-bottom: 16px;
      // }
      &:first-child {
        margin-bottom: 16px;
      }
    }
    // 后两个div 宽度50%
    .avrage {
      width: calc(50% - 8px);
      height: 93px;
      border-radius: 10px;
    }
    .avrage.left {
      margin-right: 16px;
    }
  }
  .video-padding {
    padding-top: 12px;
    .topbg {
      height: calc(100% - 24px);
      background: url("../../../assets/img/home/top_bar.png");
      background-position: 100% 98%;
      background-size: 127px 37px;
      background-repeat: no-repeat;
    }
    &:nth-of-type(2) {
      .video-content {
        height: calc(100% - 14px);
        background: url("../../../assets/img/home/right_pie.png");
        background-size: 101% 100%;
        background-repeat: no-repeat;
        div {
          margin-left: 16px;
          margin-top: 14px;
        }
      }
    }
    &:nth-of-type(3) {
      .video-content {
        height: calc(100% - 14px);

        background: url("../../../assets/img/home/right_pie.png");
        background-size: 101% 100%;
        background-repeat: no-repeat;
        // padding: 0;
        div {
          margin-left: 16px;
          margin-top: 14px;
        }
      }
    }
  }
  .video-title {
    // font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    margin-left: 12px;
    .datePng {
      vertical-align: top;
      padding-right: 8px;
    }
    .title_text {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
  }
  .video-content {
    display: flex;
    align-items: end;
    justify-content: flex-end;
    height: 50px;
    // padding: 14px 12px 0 16px;
    padding: 0px 20px 15px 0px;
    img {
      height: 28px;
    }
    div {
      font-size: 12px;
      margin-right: 5px;
    }
    span {
      display: inline-block;
      font-size: 24px;
      font-weight: 600;
    }
    .firstSpan {
      font-size: 32px;
    }
  }
  .system-jump {
    // &>div{
    //     width: 100%;
    //     height: 64px;
    //     background: #FFFFFF;
    //     border-radius: 10px;
    //     border: 1px solid #D1DBE2;
    //     margin-bottom: 16px;
    //     display: flex;
    //     align-items: center;
    //     padding: 0 21px 0 16px;
    //     color: rgba(0, 0, 0, 0.85);
    //     cursor: pointer;
    //     &:hover{
    //         border-color: #1890FF;
    //         color: #1890FF;
    //     }
    //     img{
    //         margin-right: 12px;
    //     }
    //     &>div:nth-of-type(2){
    //         margin-left: auto;
    //     }
    // }
    .top_systemInto,
    .bottom_publicCheck {
      width: 100%;
    }
    .bottom_publicCheck {
      height: 210px;
      background-image: url(../../../assets/img/home_to_doubleRandom.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #f6f8fa;
      font-size: 30px;
      text-align: center;
      font-weight: 700;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      border-radius: 5px;
      cursor: pointer;
    }
    .top_systemInto {
      height: 120px;
      display: flex;
      justify-content: space-between;
      color: #ffffff;
      margin-bottom: 24px;
      .leftInto {
        width: calc(50% - 8px);
        background-image: url(../../../assets/img/experts.png);
        background-size: 100% 100%;
        cursor: pointer;
      }
      .rightInto {
        width: calc(50% - 8px);
        background-image: url(../../../assets/img/openBid.png);
        background-size: 100% 100%;
        cursor: pointer;
      }
      .left_margin :first-child {
        font-size: 18px;
        margin-bottom: 8px;
      }
      .left_margin :first-child {
        font-size: 18px;
        margin-bottom: 8px;
      }
      .left_margin {
        margin-left: 16px;
        margin-top: 12px;
      }
    }
  }
  .right-opt {
    font-weight: 400;
    height: 28px;
    margin-top: 10px;
    line-height: 28px;
    width: 96px;
    float: right;
    border: 1px solid #cccccc;
    border-radius: 0px 2px 2px 0px;
    span {
      padding: 0;
      display: inline-block;
      width: 47px;
      text-align: center;
      cursor: pointer;
    }
    .opt-active {
      color: #ffffff;
      background-color: #1890ff;
    }
  }
}
.top-middle-right {
  border-left: 1px solid #eeeeee;
  height: 100%;
  overflow: hidden;
  .handle_count {
    display: flex;
    .num_red {
      width: calc(50% - 8px);
      height: 96px;
      background: linear-gradient(90deg, #ff7676 0%, #ff7676 0%, #ffdddd 100%);
      border-radius: 4px;
      margin-left: 16px;
      position: relative;
      cursor: pointer;
      & > div {
        color: #ffffff;
        &:nth-of-type(1) {
          font-size: 16px;
          margin: 20px 0 19px 18px;
        }
        &:nth-of-type(2) {
          font-size: 14px;
          margin-left: 21px;
          span {
            font-size: 32px;
          }
        }
      }
      img {
        position: absolute;
        top: 37px;
        right: 0px;
      }
    }
  }
  .num-yellow {
    // width: 100%;
    // height: 128px;
    width: calc(50% - 8px);
    height: 96px;
    background: linear-gradient(306deg, #ffd24d 0%, #ff9c00 100%);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    & > div {
      color: #ffffff;
      &:nth-of-type(1) {
        font-size: 16px;
        margin: 20px 0 19px 18px;
      }
      &:nth-of-type(2) {
        font-size: 14px;
        margin-left: 21px;
        span {
          font-size: 32px;
        }
      }
    }
    img {
      position: absolute;
      top: 37px;
      right: 0px;
    }
  }
  .num-blue {
    width: 100%;
    height: 96px;
    position: relative;
    overflow: hidden;
    margin: 0 0 20px 0;
    .content {
      width: 25px;
      height: 112px;
      transform: rotate(-12deg);
      position: absolute;
      top: -5px;
      left: 0px;
      z-index: 2;
      border-right: 10px solid #e7f3ff;
      background-color: #fff;
    }
    .blueNum_bg {
      background: linear-gradient(307deg, #35c3ff 0%, #1890ff 100%);
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px 0px 0px 4px;
      width: calc(50% + 25px);
      min-width: 90px;
      max-width: calc(100% - 90px);
      height: 100%;
      overflow: hidden;
      cursor: pointer;
      & > div {
        color: #ffffff;
        font-size: 14px;
        &:nth-of-type(1) {
          margin-left: 3px;
          margin-top: 9px;
        }
        &:nth-of-type(2) {
          margin-top: 21px;
          padding-left: 10px;
          span {
            font-size: 32px;
            font-weight: 600;
          }
        }
      }
    }
    .grayNum_bg {
      position: absolute;
      top: 0;
      right: 0px;
      width: calc(50% - 25px);
      min-width: 90px;
      max-width: calc(100% - 90px);
      height: 100%;
      //   z-index: 1002;
      background: #e7f3ff;
      border-radius: 0px 4px 4px 0px;
      padding-left: 10px;
      cursor: pointer;
      & > div {
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        &:nth-of-type(1) {
          margin-top: 9px;
        }
        &:nth-of-type(2) {
          margin-top: 21px;
          margin-left: 12px;
          span {
            font-size: 32px;
            font-weight: 600;
          }
        }
      }
    }
    .num-blue-middle {
      position: absolute;
      left: calc(50% - 15px);
      top: 0px;
      .white_border {
        position: relative;
        top: -100px;
        left: -12px;
        z-index: 1000;
        border-top: 160px solid #fff;
        border-left: 64px solid transparent;
      }
      .triangle {
        width: 0;
        height: 0;
        position: relative;
        top: 0;
        right: 0;
        z-index: 1001;
        border-top: 100px solid #e7f3ff;
        border-left: 40px solid transparent;
      }
    }
  }

  .num-chart {
    width: 100%;
    height: 452px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    margin-top: 31px;
    margin-bottom: 15px;
    .chart-title {
      margin: 19px 0 20px 21px;
      font-weight: 500;
      color: #000000;
      font-size: 16px;
    }
    #warning {
      height: 310px;
    }
    .chart-descrit {
      font-weight: 600;
      color: #000000;
      text-align: center;
      font-size: 16px;
      margin-top: 15px;
    }
  }
}

/* 隐藏水平滚动条 */
.hide-scrollbar ::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

.hide-scrollbar {
  -ms-overflow-style: none;  /* IE, Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>
